import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@sobidogam/tokens/tokens.css";
import "@sobidogam/product-ui/styles.css";
import { createInstallIdentity } from "@sobidogam/platform-ports";
import { ProductApp } from "@sobidogam/product-ui";

const identity = createInstallIdentity(localStorage, "web");
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || window.location.origin;

if ("serviceWorker" in navigator)
	window.addEventListener("load", () => {
		void navigator.serviceWorker.register("/sw.js");
	});

const colorScheme = window.matchMedia("(prefers-color-scheme: dark)");
const applyTheme = () => {
	document.documentElement.dataset.theme = colorScheme.matches
		? "dark"
		: "light";
};
applyTheme();
colorScheme.addEventListener("change", applyTheme);
const root = document.getElementById("root");
if (!root) throw new Error("root element is missing");
createRoot(root).render(
	<StrictMode>
		<ProductApp
			channel="web"
			apiBaseUrl={apiBaseUrl}
			identity={identity}
			webPushPublicKey={import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY}
		/>
	</StrictMode>,
);
